import { UI_APP_ICON_STORAGE_KEY, appIconFromRestDoc, appIconHref, parseAppIconStyle, type AppIconStyle } from './uiThemeCore'

/**
 * ไอคอนแอป (favicon + apple-touch-icon) — สลับ <link> ใน <head> ตามที่แอดมินเลือก
 * ค่าจาก localStorage ใส่ทันทีตอนเปิดหน้า · ค่าสดมากับ REST ของฉากหลัง (`sceneMode.ts` เรียก `syncAppIconFromDoc`)
 * จำ href เดิมใน data-default-href — เลือก 'default' แล้วคืนไอคอนเดิมได้
 */
const LINK_SELECTOR = 'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'

export function applyAppIcon(style: AppIconStyle): void {
  const href = appIconHref(style)
  document.querySelectorAll<HTMLLinkElement>(LINK_SELECTOR).forEach((link) => {
    if (!link.dataset.defaultHref) link.dataset.defaultHref = link.getAttribute('href') || ''
    if (!link.dataset.defaultType) link.dataset.defaultType = link.getAttribute('type') || ''
    if (href) {
      link.href = href
      link.type = 'image/jpeg'
    } else {
      link.href = link.dataset.defaultHref || link.href
      if (link.dataset.defaultType) link.type = link.dataset.defaultType
    }
  })
}

/** ตอนเปิดหน้า: ใส่ค่าที่จำไว้ (ค่าเดิม = ไม่แตะ) */
export function applyStoredAppIcon(): void {
  try {
    const stored = parseAppIconStyle(localStorage.getItem(UI_APP_ICON_STORAGE_KEY))
    if (stored && stored !== 'default') applyAppIcon(stored)
  } catch {
    /* private mode */
  }
}

/** response REST ของ ordercusUi มาแล้ว → จำค่า + ใส่ไอคอน */
export function syncAppIconFromDoc(doc: unknown): void {
  const style = appIconFromRestDoc(doc)
  try {
    localStorage.setItem(UI_APP_ICON_STORAGE_KEY, style)
  } catch {
    /* private mode / quota */
  }
  applyAppIcon(style)
}
